import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const listPaymentMethods = async () => {
  try {
    const response = await client.get("/payment/payment-methods");
    return response.data;
  } catch (err) {
    throw err
  }
};

export const getPaymentMethod = async (paymentMethodId) => {
  try {
    const response = await client.get(
      `/payment/payment-methods/${paymentMethodId}`
    );
    return response.data;
  } catch (err) {
    throw err
  }
};

export const createSetupIntent = async () => {
  try {
    const response = await client.post("/payment/create-setup-intent");
    return response.data;
  } catch (err) {
    throw err
  }
};

export const updatePaymentMethod = async (paymentMethodId, billingDetails) => {
  try {
    const response = await client.patch(`/payment/payment-methods/${paymentMethodId}`, {
      billing_details: billingDetails,
    });
    return response.data;
  } catch (err) {
    throw err
  }
};

export const detachPaymentMethod = async (paymentMethodId) => {
  try {
    const response = await client.delete(`/payment/payment-methods/${paymentMethodId}`);
    return response.data;
  } catch (err) {
    throw err
  }
};